import EditWebhook from "./EditWebhook";
export default EditWebhook;